module.exports = __webpack_public_path__ + "img/gdTitle.dd1979a3.jpg";